// extracted by mini-css-extract-plugin
module.exports = {"postContainer":"postContainer--_CKR3","container":"container--1TV4N","optionsContainer":"optionsContainer--2EtcS","divider":"divider--2MoAJ"};